import { IState } from 'shared/store';

import { isInRegionSelector } from '../offerData';

export const selectIsBuildersProjectsBannedEnabled = (state: IState): boolean => {
  return isInRegionSelector(state.buildersProjectsLocations)(state);
};
